export enum PaymentPlanCodes {
  Free = 'tablesready-free',
  Enterprise = 'tablesready-premium-enterprise',
}
